import React, { createContext, useContext } from 'react';

export interface PageHeaderState {
  title?: React.ReactNode;
  controls?: React.ReactNode;
}

interface PageHeaderContextValue {
  pageHeader: PageHeaderState | null;
  setPageHeader: React.Dispatch<React.SetStateAction<PageHeaderState | null>>;
}

export const PageHeaderContext = createContext<PageHeaderContextValue>({
  pageHeader: null,
  setPageHeader: () => undefined,
});

export const usePageHeader = () => useContext(PageHeaderContext);
